var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',{staticClass:"badge-success badge-pill cursor-pointer",on:{"click":function($event){return _vm.action(_vm.data, 'show')}}},[_vm._v(" "+_vm._s(this.data.user.name+" "+this.data.user.lastName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }